<template>
  <div
    class="app-container"
    :class="{
      desktop: isDesktop,
      'is-ios': isIOS,
      'booking-flow': isBookingFlow,
    }"
  >
    <router-view />
  </div>
</template>

<script>
import { clickTracking } from '@/utils/clickTracking';
import CompanyService from './services/CompanyService';

const MAX_SESSION_TIME_MIN = 30;
const MAX_SESSION_TIME_MS = MAX_SESSION_TIME_MIN * 60 * 1000;
const TIMESTAMP_KEY = 'booking_session_start_time';

export default {
  data() {
    return {
      reloadIntervalId: null,
    };
  },
  mounted() {
    this.handleTekmetricRedirect();
    this.importGrecaptchaScript();
    this.handleQueryParams();

    this.initializeTimestamp();

    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    this.reloadIntervalId = setInterval(this.checkAndReload, 60 * 1000);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);

    clearInterval(this.reloadIntervalId);
  },
  methods: {
    async handleTekmetricRedirect() {
      const accountSlug = this.$route.query?.preselect_account || null;
      if (!accountSlug) {
        return;
      }
      const { data: { has_tm_booking, tm_booking_link } } = await CompanyService.get.accountTekmetricLink(accountSlug);
      if (!has_tm_booking) {
        return;
      }
      window.location.href = tm_booking_link;
    },
    initializeTimestamp() {
      sessionStorage.setItem(TIMESTAMP_KEY, Date.now().toString());
    },
    checkAndReload() {
      const sessionStartTime = sessionStorage.getItem(TIMESTAMP_KEY);

      if (!sessionStartTime) return;

      const elapsed = Date.now() - parseInt(sessionStartTime, 10);

      if (elapsed > MAX_SESSION_TIME_MS) {
        sessionStorage.removeItem(TIMESTAMP_KEY);
        window.location.reload();
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.checkAndReload();
      }
    },
    importGrecaptchaScript() {
      if (document.querySelector('.grecaptcha-script')) return;

      const script = document.createElement('script');
      script.className = 'grecaptcha-script';
      script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    },
    handleQueryParams() {
      // Handle RWG token
      if (this.$route.query.rwg_token) {
        const queryRwgToken = this.$route.query.rwg_token;
        const rwgToken = JSON.stringify({
          token: queryRwgToken,
          timestamp: Date.now(),
        });
        localStorage.setItem('rwg_token', rwgToken);
      }

      this.handleSgClickUUID();
    },
    handleSgClickUUID() {
      // Handle click tracking UUID
      if (this.$route.query.sg_click_uuid) {
        clickTracking.setClickUUID(this.$route.query.sg_click_uuid);
        this.$posthog.capture('click_tracking', {
          event: 'landing_with_uuid',
          uuid: this.$route.query.sg_click_uuid,
        });
      } else if (clickTracking.shouldCreateNewClick(this.$route.query)) {
        clickTracking.fetchClickUUID(this.$route.query.preselect_account, this.$route.query);
        this.$posthog.capture('click_tracking', {
          event: 'click_uuid_created',
          account_slug: this.$route.query.preselect_account,
          query_params: this.$route.query,
        });
      }
    },
  },
  computed: {
    isDesktop() {
      const { desktop } = this.$route.query;
      if (desktop === undefined) return false;
      return !!Number(desktop);
    },
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    isBookingFlow() {
      return ['general-repair', 'otp'].includes(this.$route.name);
    },
  },
};
</script>
